/* eslint-disable react/prop-types */
import React from 'react';
import {
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';

const WorkNeeds = ({ vocWork, setVocWork, globalNeeds }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }}
  >
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocWork.meetings}
          onChange={() => setVocWork({ ...vocWork, meetings: !vocWork.meetings })}
          name="meetings"
          color="primary"
        />
    )}
      label={`meetings (${globalNeeds.meetings})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocWork.presentations}
          onChange={() => setVocWork({ ...vocWork, presentations: !vocWork.presentations })}
          name="presentations"
          color="primary"
        />
    )}
      label={`presentations (${globalNeeds.presentations})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocWork.negotiations}
          onChange={() => setVocWork({ ...vocWork, negotiations: !vocWork.negotiations })}
          name="negotiations"
          color="primary"
        />
    )}
      label={`negotiations (${globalNeeds.negotiations})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocWork.emails}
          onChange={() => setVocWork({ ...vocWork, emails: !vocWork.emails })}
          name="emails"
          color="primary"
        />
    )}
      label={`emails (${globalNeeds.emails})`}
    />
    <FormControlLabel
      control={(
        <Checkbox
          checked={vocWork.telephoning}
          onChange={() => setVocWork({ ...vocWork, telephoning: !vocWork.telephoning })}
          name="telephoning"
          color="primary"
        />
    )}
      label={`telephoning (${globalNeeds.telephoning})`}
    />
  </div>
);

export default WorkNeeds;
